import type { MaterializedMenuProduct } from '@iheartjane/data-access';
import {
  doesSpecialApply,
  getSpecialIdsForTagLabel,
  getSpecialTagLabel,
} from '@iheartjane/menu';
import type {
  ComplianceLanguageSettings,
  Nullable,
  Nullish,
} from '@iheartjane/types';

import { getSpecialBadgeLabel } from '@jane/bloom/viewModels/getPrice';
import type { StoreSpecials } from '@jane/bloom/viewModels/schemas/storeSpecials';

interface GetSpecialLabelArgs {
  bundleTag: boolean;
  product: MaterializedMenuProduct;
  specials: Nullish<StoreSpecials>;
  storeComplianceLanguageSettings: Nullable<ComplianceLanguageSettings>;
}

export const getSpecialLabel = ({
  bundleTag,
  product,
  specials,
  storeComplianceLanguageSettings,
}: GetSpecialLabelArgs): string => {
  const applicableSpecial = bundleTag
    ? specials
        ?.filter(Boolean)
        .find((special) =>
          doesSpecialApply(
            getSpecialIdsForTagLabel(product),
            special.id,
            special.special_type
          )
        )
    : undefined;

  const label = bundleTag
    ? applicableSpecial
      ? getSpecialTagLabel({
          product,
          store: {
            store_compliance_language_settings: storeComplianceLanguageSettings,
          },
        })
      : ''
    : getSpecialBadgeLabel(product, storeComplianceLanguageSettings);

  return label ?? '';
};
